<script>
import * as d3 from 'd3'

import LineChart from '@/components/plots/LineChart'

export default {
  computed: {
    curve_type() {
      switch(this.step) {
        case 'before':
          return d3.curveStepBefore
        case 'after':
          return d3.curveStepAfter
        default:
          return d3.curveStep
      }
    }
  },
  extends: LineChart,
  name: 'candela-line-chart-stepped',
  props: {
    step: {type: String, default: () => 'normal'}
  }
}
</script>
